import { useEffect, useState } from 'react';

import { AppBar, Collapse, Chip, Tooltip, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { useModal } from 'react-modal-hook';

import * as socketEvents from 'constants/socketEvents';
import socket from 'services/socket';
import { CanalInterface } from 'store/reducers/canais';

import ModalAutorizarConexaoCanal from './ModalAutorizarConexaoCanal';

const useStyles = makeStyles(({ palette, spacing, zIndex }) => ({
  appBar: {
    height: spacing(5),
    padding: spacing(1, 0),
    color: palette.text.primary,
    backgroundColor: palette.background.tertiary,
    zIndex: zIndex.drawer + 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  menu: {
    width: '100%',
  },
  menuWrapper: {
    width: '100%',
    margin: spacing(0, 0.5),
  },
}));

export default function BarraCanaisDesconectados() {
  const classes = useStyles();
  const [canalSelected, setCanalSelected] = useState<CanalInterface>();
  const [canaisDesconectados, setCanaisDesconectados] = useState<
    CanalInterface[]
  >([]);

  useEffect(() => {
    const handler = (data: CanalInterface) => {
      setCanaisDesconectados(prevState => {
        const { canalId, online, status } = data;
        const index = prevState.findIndex(canal => canal.canalId === canalId);
        const newState = [...prevState];

        // Verifica se o canal está online ou DESATIVADO
        if (online || status === 'DESATIVADO') {
          // Remove o canal da lista se ele ainda estiver lá
          if (index > -1) newState.splice(index, 1);

          // Atualiza os dados e o STATUS do canal se ele for encontrado na lista
        } else if (index > -1) {
          newState[index] = {
            ...newState[index],
            canalId: data.canalId,
            online: data.online,
            status: data.status,
          };

          // Adiciona o canal na lista se sua conexão caiu (online = false) e ele ainda não está na lista
        } else newState.push(data);

        return newState;
      });
    };

    socket.on(socketEvents.ON_CONEXAO_STATUS, handler);

    return () => {
      socket.off(socketEvents.ON_CONEXAO_STATUS, handler);
    };
  }, []);

  const [showModalAutorizarConexaoCanal, hideModalAutorizarConexaoCanal] =
    useModal(
      ({ in: open }) => (
        <ModalAutorizarConexaoCanal
          open={open}
          onClose={hideModalAutorizarConexaoCanal}
          canal={canalSelected}
        />
      ),
      [canalSelected],
    );

  const handleReconnect = (canal: CanalInterface) => {
    const { canalId, tipoCanal } = canal;

    // Canais WHATSAPP_OFICIAL só emitem conexaoStatus quando estão em modo híbrido (conexão via QR Code)
    const isConexaoViaQrCode =
      tipoCanal === 'WHATSAPP' || tipoCanal === 'WHATSAPP_OFICIAL';

    if (isConexaoViaQrCode) {
      setCanalSelected(canal);
      showModalAutorizarConexaoCanal();
    } else {
      socket.emit(socketEvents.EMIT_RECONECTAR_CANAL, { canalId });
    }
  };

  const renderCanais = canaisDesconectados.map(canal => {
    const { canalId, status, canalNome } = canal;
    const conectando = status === 'CONECTANDO';

    return (
      <Tooltip
        key={canalId}
        title={conectando ? 'conectando...' : `conectar "${canalNome}"`}
      >
        <Box ml={1} mr={1}>
          <Chip
            size="small"
            color="secondary"
            label={canalNome}
            disabled={conectando}
            onClick={() => handleReconnect(canal)}
          />
        </Box>
      </Tooltip>
    );
  });

  return (
    <Collapse
      in={canaisDesconectados.length > 0}
      collapsedSize={40}
      unmountOnExit
      mountOnEnter
    >
      <AppBar elevation={0} position="relative" className={classes.appBar}>
        <ScrollMenu
          data={renderCanais}
          alignCenter={false}
          menuClass={classes.menu}
          wrapperClass={classes.menuWrapper}
          hideSingleArrow
        />
      </AppBar>
    </Collapse>
  );
}
